if (typeof Promise.withResolvers !== 'function') {
  // @ts-ignore
  Promise.withResolvers = function() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export default defineNuxtPlugin({});
